import { ReactNode, ReactPortal } from "react"
import { ReactQueryProvider } from "./ReactQuery"
import { AccountProvider } from "./Account";
import { StoreProvider } from "./Store";

type Props = {
  children: ReactNode | ReactPortal;
}

export const ContextWrapper = ({ children }: Props) => {
  return (
    <AccountProvider>
      <StoreProvider>
        <ReactQueryProvider>
          {children}
        </ReactQueryProvider>
      </StoreProvider>
    </AccountProvider>
  );
};
